<div class="w-full section-padding-vertical-md lg:section-padding-vertical-lg pt-0 z-10 relative">
    <div
        class="bg-dark w-full rounded-large flex flex-col gap-large spacing-md lg:flex-row md:spacing-lg relative">
        <!-- content -->
        <div class="flex flex-col gap-medium text-white w-full my-auto">
            <h1 class="text-white">
                Von
                <span class="relative">
                    austauschbar
                    <svg
                        class="button-stroke h-8 w-full absolute stroke-6 md:stroke-8 left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/3 stroke-primary-500"
                        viewBox="0 0 154 13">
                        <path
                            id="line"
                            d="M2 2c49.7 2.6 100 3.1 150 1.7-46.5 2-93 4.4-139.2 7.3 45.2-1.5 90.6-1.8 135.8-.6"
                            fill="none"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            vector-effect="non-scaling-stroke" />
                    </svg>
                </span>
                zum
                <span
                    class="font-medium bg-gradient-to-r from-secondary-300 to-secondary-600 bg-clip-text text-transparent"
                    >Marktführer</span
                >, mit einer verkaufsstarken Website.
            </h1>

            <p class="text-lg">
                In 2026 musst <span class="font-semibold">DU</span> deine Besucher überzeugen, noch
                bevor du ein Wort sagst. Und das schneller als deine Konkurrenz.
            </p>

            <wci-button routerLink="/kontakt" label="Jetzt kostenloses Erstgespräch anfragen"
                >Jetzt kostenloses Erstgespräch anfragen
            </wci-button>
        </div>

        <!-- image -->
        <div class="relative w-full">
            <div
                class="absolute w-full aspect-square rounded-large bg-secondary-600 opacity-15 right-[7.5%] bottom-[-7.5%] blur-[100px]"></div>

            <div class="rounded-large w-full bg-muted overflow-hidden relative flex aspect-[1/1.15]">
                <wci-image-marquee
                    [images]="screen_strip"
                    class="absolute inset-0 rotate-[-10deg] scale-120"></wci-image-marquee>
                <div
                    class="absolute inset-0 bg-gradient-to-t from-secondary-600/70 via-secondary-600/10 to-secondary-600/30"></div>
                <img
                    src="images/wecodeit_team.webp"
                    class="z-50 relative mt-auto" width="1282" height="1451"
                    alt="Das Team von WeCodeIt" />
                <div
                    class="absolute inset-0 bg-gradient-to-t from-dark/100 to-dark/0 h-1/2 bottom-0 top-auto z-50"></div>
            </div>
        </div>
    </div>
</div>
